import { verifyPermission } from '../helpers/roleBasedAccess';


const Protected = ({ controller, action,  children }) =>  {


  const isLoggedIn = localStorage.getItem('token');
    if(isLoggedIn === 'undefined' || !isLoggedIn ){
      return children[0];
    }

    if(controller && action){
    const permission = verifyPermission(controller, action)
    

    if(permission == true)
    {
      return children[1] ;
    }else{

      localStorage.setItem('success_msg','You have no permission to access this page')
      window.location.href = '/';
    }

  }else{
    return children[1] ;

  }
}

export default Protected;